import React from "react";

// Layout
import BaseLayout from "../base";

// Style
import { PageContent } from "./style";

const DetailsSidebarFrontBaseLayout = ({ children, ...rest }) => {
  return (
    <BaseLayout {...rest}>
      <PageContent>
        {children}
      </PageContent>
    </BaseLayout>
  );
};

export default DetailsSidebarFrontBaseLayout;
